import { getDateTimeFormatter } from '@fe/core';
import { GDFFcaRecord, GDFFcaType } from '../../../gdf/type';

export default function TcaTooltip({ record }: { record: GDFFcaRecord }) {
    const formatter = getDateTimeFormatter();
    return (
        <div>
            <div>{record.subType === GDFFcaType.fca ? 'FCA' : 'FEA'}</div>
            <div style={{ display: 'grid', gridTemplateColumns: 'max-content auto', columnGap: '1rem' }}>
                <div>Name:</div>
                <div>{record.label.slice(0, 50) || '-'}</div>

                <div>AFP:</div>
                <div>{record.flags & 0x01 ? 'Yes' : 'No'}</div>

                <div>FSM eligible:</div>
                <div>{record.flags & 0x02 ? 'Yes' : 'No'}</div>

                <div>Extended FEA:</div>
                <div>{record.flags & 0x04 ? 'Yes' : 'No'}</div>

                <div>Reason:</div>
                <div>{record.detail.slice(0, 50)}</div>

                {(record.fcaStartTime || record.fcaEndTime) && (
                    <>
                        <div>FCA: start/end:</div>
                        <div>
                            {formatter.formatTime(record.fcaStartTime, 'hm') || '?'} -{' '}
                            {formatter.formatTime(record.fcaEndTime, 'hm') || '?'}
                        </div>
                    </>
                )}

                {(record.afpStartTime || record.afpEndTime) && (
                    <>
                        <div>AFP start/end:</div>
                        <div>
                            {formatter.formatTime(record.afpStartTime, 'hm') || '?'} -{' '}
                            {formatter.formatTime(record.afpEndTime, 'hm') || '?'}
                        </div>
                    </>
                )}

                <div>Altitude:</div>
                <div>
                    {record.floor?.toString().padStart(3, '0') ?? '?'} - {record.ceiling?.toString().padStart(3, '0') ?? '?'}
                </div>

                <div>Average delay</div>
                <div>
                    {record.avgDelay ?? '-'} {record.avgDelay && ' minutes'}
                </div>
            </div>
        </div>
    );
}
